import { get as getWorkTypes } from 'serviceWorker/db/fieldValues/worktypes/worktypes';
import { IssueEntity } from 'serviceWorker/repository/issue/entity';
import {
  ChartValuesAndLabels,
  FilterValues,
  IssueChart,
} from 'shared/types/analytics';
import { HashMap, LabelledEntity } from 'shared/types/commonView';
import {
  increaseEntitySeries,
  increaseNoneSeries,
  toSortedValuesAndLabels,
} from '../seriesCreation';
import { filterIssuesByChartFilters } from '../issueChartFilters';
import type { ChartAdditionalParams } from 'shared/domain/analytics/chartModel';
import { keepIssuesOfVisibleProcesses } from '../model';

export async function createSeriesAndLabelsFromIssuesWithFilters(
  issues: IssueEntity[],
  filters: FilterValues,
  timezone: string,
  additionalParams: ChartAdditionalParams | undefined
): Promise<ChartValuesAndLabels> {
  const workTypesLabels = {};
  const workTypesMap = (await getWorkTypes()).reduce((map, workType) => {
    map.set(workType._id, {
      _id: workType._id,
      label: workType.label,
    });
    return map;
  }, new Map<string, LabelledEntity>());

  const filteredIssues = keepIssuesOfVisibleProcesses(
    filterIssuesByChartFilters(
      issues,
      IssueChart.workType,
      filters,
      timezone
    ),
    additionalParams
  );

  const reducedToWorkTypesSummary = filteredIssues.reduce<HashMap<number>>(
    (result, issue) => {
      const workTypes = issue.extendedData.workTypes || [];

      if (!workTypes.length) {
        increaseNoneSeries(result, workTypesLabels);
      } else {
        workTypes.forEach((workType) =>
          increaseEntitySeries(
            result,
            workTypesLabels,
            workTypesMap.get(workType)!
          )
        );
      }

      return result;
    },
    {}
  );

  return toSortedValuesAndLabels(
    reducedToWorkTypesSummary,
    workTypesLabels
  );
}
